import { get, post } from './common'

type ApiBaseResult<T> = ApiTypes.ApiBaseResult<T>
type ApiBasePageResult<T> = ApiTypes.ApiBasePageResult<T>

export namespace material {
  // 素材列表
  export function search(data: PostData.Material.SearchModel) {
    return post<ApiBasePageResult<ServerData.Material.MaterialItem>>(
      '/materials/search',
      {},
      { ...data }
    )
  }

  // 素材详情
  export function detail(data: PostData.Material.DetailModel) {
    return get<ApiBaseResult<ServerData.Material.DetailData>>('/materials/one', { ...data })
  }

  // 素材修改
  export function update(data: PostData.Material.UpdateModel) {
    return post<ApiBaseResult<null>>('/material/update', {}, { ...data })
  }

  // 附件上传
  export function uploadAttachment(data: PostData.Material.AttachmentModel) {
    return post<
      ApiBaseResult<{ fileName: string; filePath: string; fileSize: number; id: number }>
    >('/material/attachment/add', {}, { ...data })
  }

  // 附件列表
  export function getAttachmentList(data: { workspaceId?: string; materialId?: number }) {
    return get<ApiBaseResult<ServerData.Material.AttachmentItem[]>>('/material/attachment/list', {
      ...data,
    })
  }

  // 附件删除
  export function deleteAttachment(data: {
    workspaceId?: string
    materialId?: number
    materialAttachmentId?: number
  }) {
    return post<ApiBaseResult<null>>('/material/attachment/delete', {}, { ...data })
  }

  // 文件上传
  export function upload(workspaceId: string, file: File) {
    const formData = new FormData()
    formData.append('workspace_id', workspaceId)
    formData.append('file', file, file.name)
    return post<
      ApiBaseResult<{
        materialId: boolean
        msgCode: number
      }>
    >('/material/upload', {}, formData)
  }

  // 素材数量统计
  export function sum(data: PostData.Material.SumModel) {
    return get<ApiBaseResult<{ reviewCount: number; approvedCount: number }>>(
      '/material/sum_total',
      { ...data }
    )
  }

  // 批量修改标签
  export function batchUpdateTag(data: PostData.Material.BatchUpdateTagModel) {
    return post<ApiBaseResult<null>>('/material/batch_update_tag', {}, { ...data })
  }

  // 批量修改版权
  export function batchUpdateCopyright(data: PostData.Material.BatchUpdateCopyrightModel) {
    return post<ApiBaseResult<null>>('/material/batch_update_copyright', {}, { ...data })
  }

  // 批量关联文件夹
  export function batchUpdateFolder(data: PostData.Material.BatchUpdateFolderModel) {
    return post<ApiBaseResult<null>>('/material/batch_update_folder', {}, { ...data })
  }

  // 批量删除
  export function batchDelete(data: PostData.Material.BatchDeleteModel) {
    return post<ApiBaseResult<null>>('/material/batch_delete', {}, { ...data })
  }

  // 批量审核
  export function batchAudit(data: PostData.Material.BatchReviewModel) {
    return post<ApiBaseResult<null>>('/material/batch_review', {}, { ...data })
  }

  // 素材来源
  export function getSource(workspaceId: string) {
    return get<ApiBaseResult<ServerData.FileSourceData[]>>('/enum/source_name', { workspaceId })
  }

  // 下载上报
  export function downloadLog(data: {
    workspaceId: string
    materialId?: number | string
    attachmentId?: number | string
    action: 'download' | 'copy'
  }) {
    return post<ApiBaseResult<null>>('/material/download', {}, data).catch((err) => {
      console.log(err)
    })
  }

  // 保存COS文件信息
  export function saveCosFileInfo(data: PostData.Material.SaveCosFileInfoModel) {
    return post<
      ApiBaseResult<{
        materialId: number
        msgCode: number
      }>
    >('/material/upload_path', {}, { ...data })
  }

  // 置顶
  export function setTop(data: PostData.Material.SetTopModel) {
    return post<ApiBaseResult<null>>('/material/set_top', {}, { ...data })
  }
}
